import { useEffect, useState } from 'react';
import { getTranslation } from '../../../Js/React/Services/legacy';

//todo handle multiple keys
export const useBizTranslation = (phraseKey: string) => {
	const [translation, setTranslation] = useState<string>();

	useEffect(() => {
		getTranslation(phraseKey).then((result) => {
			if (result) {
				setTranslation(result);
			} else {
				console.warn(`Translation for key "${phraseKey}" not found.`);
			}
		});
	}, []);

	return translation;
};
